module.exports = __webpack_public_path__ + "media/icons/presentation-deck-c942d2ed.png";